import React, {useState} from 'react';
import {Card, Grid} from '@mui/material';
import Typography from '@mui/material/Typography';
import {MultipleImageUpload} from '../../../common/ImageUpload/MultipleImage';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

export default function CatalogueAttachments({setArtefactImgIds, imgId, artefactImgIds}) {
  const [value, setValue] = useState('no');

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  return (
    <Grid container spacing={2}>
      <Grid item sm={4} xs={12}>
        <Card className={'box-shadow'} sx={{p: 4}}>
          <Typography>Artefact Photo</Typography>
          <MultipleImageUpload setImageId={setArtefactImgIds} imgId={imgId} acquisitionImgIds={artefactImgIds}/>
        </Card>
      </Grid>
      {/*<Grid item sm={2.5} xs={12}>*/}
      {/*  <Card className={'box-shadow'} sx={{p: 2}}>*/}
      {/*    <FormControl>*/}
      {/*      <FormLabel id="demo-row-radio-buttons-group-label">*/}
      {/*        Do you want to add video ?*/}
      {/*      </FormLabel>*/}
      {/*      <RadioGroup*/}
      {/*        row*/}
      {/*        aria-labelledby="demo-row-radio-buttons-group-label"*/}
      {/*        name="row-radio-buttons-group"*/}
      {/*        value={value}*/}
      {/*        onChange={handleChange}*/}
      {/*      >*/}
      {/*        <FormControlLabel value="yes" control={<Radio/>} label="Yes"/>*/}
      {/*        <FormControlLabel value="no" control={<Radio/>} label="No"/>*/}
      {/*      </RadioGroup>*/}
      {/*    </FormControl>*/}
      {/*    {value === 'yes' &&*/}
      {/*      <Typography>Feature Image</Typography>*/}
      {/*    }*/}
      {/*  </Card>*/}
      {/*</Grid>*/}
      {/*<Grid item sm={5.5} xs={12}>*/}
      {/*  {value === 'yes' &&*/}
      {/*  <Card className={'box-shadow'} sx={{p: 4}}>*/}
      {/*    Video*/}
      {/*  </Card>*/}
      {/*  }*/}
      {/*</Grid>*/}
    </Grid>
  );
}